import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import Validated from 'components/util/Validated';

import { Form } from 'common/components';

import CompaniesSchemas from 'schemas/companies_schemas';

const CompanyForm = ({
  errors = {},
  isLoading = false,
  isSubmitted = false,
  handleSubmit = () => {},
  handleValueChange = () => {},
  t = (k) => k,
  values = {},
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
      noValidate
      autoComplete="false"
    >
      <div className="row mt-3 align-items-center">
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            autoFocus={true}
            error={(isSubmitted && errors.shortname) || {}}
            name={'shortname'}
            label={t('companies.fields.shortname')}
            placeholder={t('companies.fields.shortname')}
            handleChange={handleValueChange}
            t={t}
            value={values.shortname}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            error={(isSubmitted && errors.name) || {}}
            name={'name'}
            label={t('companies.fields.name')}
            placeholder={t('companies.fields.name')}
            handleChange={handleValueChange}
            t={t}
            value={values.name}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.Checkbox
            name="active"
            className="icheckbox_flat-blue"
            onChange={handleValueChange}
            checked={values.active}
            label={t('common.active', { context: 'female' })}
          />
        </div>
        <div className="col-md-12">
          <Form.Button
            text={t('actions.save')}
            isLoading={isLoading}
            extraClassName={'pull-right btn-xs-block'}
          />

          <Form.Link
            to={'/'}
            className={classnames('btn btn-secondary pull-right mr-3', {
              disabled: isLoading,
            })}
          >
            {t('actions.cancel')}
          </Form.Link>
          <div className="clearfix" />
        </div>
      </div>
    </form>
  );
};

export default Validated(CompaniesSchemas.edit)(translate()(CompanyForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/components/CompanyForm.js